// import { Link } from "react-router-dom";

export default function Links() {
  return (
    <div className="col2">
      <a href="#">
        <b>EPISODE 2 IMAGES</b>
      </a>
      <a href="#">
        <b>EPISODE 1 IMAGES</b>
      </a>
      <a
        href="https://www.youtube.com/channel/UCXN3C-k4uohtYFIhuLvuOkQ"
        target="_blank"
      >
        <b>YOUTUBE CHANNEL</b>
      </a>
      <a href="https://www.instagram.com/masterclass_005/" target="_blank">
        <b>INSTAGRAM PAGE</b>
      </a>
      <a href="https://www.tiktok.com/@masterclass_005" target="_blank">
        <b>TIKTOK</b>
      </a>
    </div>
  );
}
